import React from 'react'
import { connect } from 'react-redux'

import builderSelectors from 'common/builder/selectors/builder'

const Context = React.createContext({})

const Provider = Context.Provider
const Consumer = Context.Consumer

const withNodeContext = (BaseComponent) => {
  const wrapper = React.forwardRef((props, ref) => (
    <Consumer>{(value) => <BaseComponent {...value} {...props} ref={ref} />}</Consumer>
  ))
  wrapper.displayName = `withNodeContext(${BaseComponent.displayName || BaseComponent.name})`
  return wrapper
}

// Provider checks that builder exists cause when builder is removed React-PIXI
// components render starts before ReactDOM components
const NodeProvider = connect((state, props) => {
  const { builderId } = props
  const builderState = builderSelectors.state.getById(state, builderId)
  if (!builderState) {
    return { ready: false }
  }

  return { ready: true }
})((props) => (props.ready ? <Provider value={props.value}>{props.children}</Provider> : null))

export { withNodeContext, NodeProvider, Context as NodeContext }
